<template>
    <div class="body">
     <section class="content">
        <div class="box box-info">
          <Toast style="margin-top: 35px" />
  
              <DataTable :value="userLists" :paginator="true" ref="po"
                       :rows="100" :filters="filters" :rowsPerPageOptions="[100,500,1000]"
                       class="p-datatable-responsive p-datatable-gridlines" data-key="id">
        <Column header="S.n" field="id"/>
        <Column header="Name" field="name" filterField="name" filterMatchMode="contains" />
        <Column header="Username" field="username" filterField="username" filterMatchMode="contains"/>
        <!-- <Column header="Role" field="role" filterField="role" filterMatchMode="contains"/> -->
        <Column header="Action">
        <!-- <template #empty>No record found</template>
        <template #body="slotProps">
          &nbsp;<Button type="button" class="btn btn-success" @click ="openEditDialog(slotProps.data)">
            <i class="fa fa-edit"/></Button>
          &nbsp;&nbsp;
           <Button type="button" class="btn btn-danger"
           @click="openDialog(slotProps.data.id)"><i class="fa fa-trash"/></Button>
        </template> -->
        <template #body="slotProps">
        <Button icon="pi pi-refresh" class="p-button-raised p-button-success"
                        @click="resetPassword(slotProps.data.id)"/>
                    </template>
        </Column>
      </DataTable>
          <!-- <userList @deleteAdminUser="deleteAdminUser" @edit-user="updateUser"/> -->
        <Dialog v-model="dialogShow" @deleted="deleteAdminUser"/>
        </div>
    </section>
    </div>
  </template>
  <script>
  import Dropdown from 'primevue/dropdown'
  import Dialogs from 'primevue/dialog'
  import Dialog from '../../layout/dialog'
  import Column from 'primevue/column'
  import DataTable from 'primevue/datatable'
  import Toast from 'primevue/toast'
  import Button from 'primevue/button'
  export default {
    name: 'userCreate',
    data() {
      return {
        name: '',
        roleId: '',
        userName: '',
        editing: false,
        password: '',
        password1: '',
        filters: {},
        showDialog: false,
        dialogShow: false,
        addDisplayBasic: false,
        userId: null,
        loading: false
      }
    },
    computed: {
      userLists() {
        return this.$store.state.admin.userLists
      }
    },
    mounted() {
      this.userList()
    },
    methods: {
      async resetPassword(value) {
        let deleteRe = {
          id: value
        }
        let resp = await this.$store.dispatch('resetUserPassword', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        }
      },
      async userList() {
        await this.$store.dispatch('loadAllUser')
      },
      async deleteAdminUser(value) {
        if (value.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
          this.dialogShow = false
          return
        }
        let deleteReason = {
          userId: this.accountId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteAdminUser', deleteReason)
        if (resp.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        }
        this.closeDialog()
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      closeDialog() {
        this.dialogShow = false
        this.showDialog = false
      },
      openEditDialog(data) {
        this.editing = true
        this.userId = data.id
        this.editing = true
        this.name = data.name
        this.userName = data.userName
        this.openAddDialog()
      },
      cancel() {
        this.dialogShow = false
      },
      updateUser(data) {
        this.name = data.name
        this.userName = data.username
        this.roleId = data.role
        this.editing = !this.editing
        this.showDialog = !this.showDialog
        this.userId = data.id
      },
      openAddDialog() {
        this.showDialog = true
      },
      cancelAdd() {
        this.name = ''
        this.userName = ''
        this.roleId = ''
        this.password = ''
        this.password1 = ''
        this.showDialog = false
        this.editing = false
      },
      resetResponse() {
        this.response = ''
        this.roleId = ''
      }
    },
    components: {
      Dropdown,
      Dialog,
      Dialogs,
      Column,
      DataTable,
      Toast,
      Button
    }
  }
  </script>
  <style>
  </style>



// WEBPACK FOOTER //
// allUserList.vue?e074fa06